import { useEffect } from "react";

const CONTROLS_HANDLING_ENTER =
  'button, a[href], textarea, select, [contenteditable="true"], [role="button"], [role="link"], [role="option"], [role="combobox"], [role="tab"], [role="menuitem"], [role="switch"]';

const isEnterHandledByTarget = (target: EventTarget | null) =>
  target instanceof Element && Boolean(target.closest(CONTROLS_HANDLING_ENTER));

export const useEnterKeyListener = (onEnter: () => void, isEnabled: boolean = true) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== "Enter" || e.defaultPrevented || isEnterHandledByTarget(e.target)) {
        return;
      }
      e.preventDefault();
      onEnter();
    };

    if (isEnabled) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (isEnabled) {
        window.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [onEnter, isEnabled]);
};
